const formatter = {
  methods: {
    /**
     * 연식 포맷팅을 설정한다
     * - ex: 00년 00월식
     * @param {*} o 연식정보
     * @return 00년 00월식
     */
    // mfgDtFormatter (o) {
    //   let number = ''
    //   if (typeof o === 'undefined') {
    //     return ''
    //   } else if (typeof o === 'object') {
    //     if (o == null) {
    //       return ''
    //     }
    //     number = o.number
    //   } else if (typeof o === 'number') {
    //     number = o.toString()
    //   } else if (typeof o === 'string') {
    //     number = o
    //   }
    //   if (o.number === null) { return }
    //   return ''.concat(number.substr(2, 2), '년', ' ', number.substr(4, 2), '월식')
    // },

    /**
     * 연식 포맷팅을 설정한다
     * - ex: 00년 00월식
     * @param mfgDt 제조일자
     * @param prdcnYr 생산년도
     * @return yy년 mm월식(yy년형)
     */
    mfgDtFormatter (mfgDt, prdcnYr) {
      const year = mfgDt.substr(0, 4)
      // const month = mfgDt.substr(4, 2)
      const subYear = year.substr(2, 2)
      const begin = prdcnYr
      const subBegin = begin.substr(2, 2)
      const mfrDateCk = mfgDt.substr(4, 1)
      let mfrDate = ''
      if (mfrDateCk > 0) {
        mfrDate = mfgDt.substr(4, 2)
      } else {
        mfrDate = mfgDt.substr(5, 1)
      }

      let strYearModel = ''
      if (begin < year) {
        strYearModel += subBegin + '년 ' + '12월식'
      } else {
        strYearModel += subYear + '년 ' + mfrDate + '월식'
      }
      if (begin > year) {
        strYearModel += '(' + subBegin + '년형) '
      }
      return strYearModel
    },
    /**
     * 주행거리 포맷팅을 설정한다
     * - 숫자 3자리마다 콤마, 단위추가(km)
     * - ex: 000,000 km
     * @param {*} value 주행거리정보
     * @return 000,000 km
     */
    milgFormatter (value) {
      return this.numberFormatter(value).concat('km')
    },
    /**
     * 금액 포맷팅을 설정한다
     * - 숫자 3자리마다 콤마, 단위추가
     * - ex: 000,000
     * @param {*} value 정보
     * @return 000,000
     */
    numberFormatter (value) {
      let number = ''
      if (typeof value === 'undefined') {
        return 0
      } else if (typeof o === 'object') {
        if (value == null) {
          return 0
        }
        number = value.number
      } else if (typeof value === 'number') {
        if (Number.isNaN(value)) {
          return 0
        }
        // number = value.toString()
        number = value
      } else if (typeof value === 'string') {
        number = Number(value)
      }
      // return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
      return number.toLocaleString('ko-KR')
    },
    /**
     * 금액 포맷팅을 설정한다
     * - 숫자 3자리마다 콤마, 단위추가(원)
     * - ex: 000,000 원
     * @param {*} value 금액 정보
     * @return 000,000 원
     */
    priceFormatter (value) {
      return this.numberFormatter(value).concat('원')
    },
    /**
     * 금액 포맷팅을 설정한다
     * - 숫자 3자리마다 콤마, 단위추가(만원)
     * - ex: 000,000 만원
     * @param {*} value 금액 정보
     * @return 000,000 만원
     */
    priceTenThousandFormatter (value) {
      const price = this.numberFormatter(value)
      return price ? price.concat('만원') : ''
    },
    /**
     * 백만단위금액을 한글표기한다
     * - ex: 125300 => 12억5천3백만원
     * @param {*} value 금액 정보
     * @return 000,000 만원
     */
    priceMillionToKor (value, separator = '') {
      let number = 0
      let quotient = 0 // 몫
      let remainder = 0 // 나머지
      const unit = [{ unit: '억', value: 10000 }, { unit: '천', value: 1000 }, { unit: '백', value: 100 }]
      const numberArr = []
      if (typeof value === 'undefined') {
        return ''
      } else if (typeof value === 'object') {
        if (value == null) {
          return ''
        }
        number = value.number
      } else if (typeof value === 'number') {
        number = value
      } else if (typeof value === 'string') {
        number = Number(value)
      }
      remainder = number
      for (let i = 0; i < unit.length; i++) {
        quotient = remainder / unit[i].value
        if (quotient > 1) {
          numberArr.push(quotient, unit[i].unit)
          remainder = remainder % unit[i].value
        }
      }
      return numberArr.length > 0 ? ''.concat(numberArr.join(separator), '만원') : ''
    },
    // 신규입고 여부를 가리기 위한 기준시각
    getNewIwhYnStnd () {
      const now = new Date()
      now.setDate(now.getDate() - 30)
      const stndDateArr = now.toISOString().split('T')[0].split('-')
      return stndDateArr[0] + stndDateArr[1] + stndDateArr[2] + '000000' // yyyymmddhh24miss
    },
    /**
     * 금액을 한글표기한다
     * - ex: 2920000 => 이천구백이십만 원
     * @param {*} value 금액
     * @returns X천X백X십만 원
     */
    numberKor (value) {
      const strValue = value + ''
      // eslint-disable-next-line no-array-constructor
      const numKor = new Array('', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구', '십')
      // eslint-disable-next-line no-array-constructor
      const unitKor = new Array('', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천')
      let result = ''
      for (let i = 0; i < strValue.length; i++) {
        let str = ''
        const han = numKor[strValue.charAt(strValue.length - (i + 1))]
        if (han !== '') {
          str += han + unitKor[i]
        }
        if (i === 4) {
          str += '만'
        }
        if (i === 8) {
          str += '억'
        }
        if (i === 12) {
          str += '조'
        }
        result = str + result
      }
      if (strValue !== 0) {
        result = result + ' 원'
      }
      return result
    },

    /**
     * 상품 list 총 개수 포맷팅
     * - 숫자 3자리마다 콤마, 단위 추가
     * - 99999 이상일 시, return 99,999+
     * @param {*} value 정보
     * @return 000,000 / 99,999+
     */
    totalSizeFormatter (value) {
      let number = ''

      if (typeof value === 'number') {
        if (Number.isNaN(value)) {
          return 0
        }
        if (value >= 99999) {
          number = '99,999+'
        } else {
          number = value
        }
      }

      return number.toLocaleString('ko-KR')
    }
  }
}

export {
  formatter
}
